import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import attributeActions from "../../../store/actions/items/attributes/attribute.actions";
import { useEffect, useState } from "react";

import "../../../styles/components/items/filterAndSort/filterAndSortProductsComponent.scss";

export const FilterAndSortProductsComponent = ({totalCount}) => {
  return (
    <div className="filterAndSortProductsContainer">
      <div className="filterAndSortContainer">
        {/* <div className="filter">
          <span className="title">סנן לפי</span>
          <span>
            מחיר <i className="fa-solid fa-angle-down"></i>
          </span>
        </div> */}
        <div className="sort">
          {/* <span className="title">מיון לפי</span>
          <span>
            מחיר <i className="fa-solid fa-angle-down"></i>
          </span> */}
        </div>
      </div>
      <span className="title">{totalCount} מוצרים</span>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  attributeActions: bindActionCreators(attributeActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterAndSortProductsComponent);
